<div class="date-to-achievements-inline">

  <h4 *ngIf="field?.label" class="field-label">{{field.label}}</h4>

  <div *ngIf="sortedRows.length > 0" class="rows-list p-mb-3">
    <div *ngFor="let row of sortedRows" class="date-to-achievements-row">
      <span class="date-badge">{{ row.date | date: 'MM/dd/yyyy HH:mm' }}</span>
      <i class="pi pi-arrow-right row-arrow"></i>
      <span class="achievement-ids">
        <span *ngFor="let id of row.achievementIds" class="achievement-chip">
          {{ getTitle(id) }}
          <a [routerLink]="'/achievements/' + id" [ngStyle]="{ color: 'var(--primary-color)' }">({{ id }})</a>
        </span>
      </span>
      <p-button
        *ngIf="!readonly"
        icon="pi pi-times"
        styleClass="p-button-text p-button-danger p-button-sm remove-btn"
        (onClick)="removeRow(row.date)"
      ></p-button>
    </div>
  </div>
  <p *ngIf="sortedRows.length === 0" class="p-text-secondary p-mb-3" style="font-size:0.875rem;">
    No dates configured yet.
  </p>

  <div *ngIf="!readonly" class="p-d-flex p-ai-center p-mb-3" style="gap: 0.75rem;">
    <p-calendar
      [(ngModel)]="newDate"
      [showTime]="true"
      [monthNavigator]="true"
      [showButtonBar]="true"
      [hideOnDateTimeSelect]="false"
      placeholder="Date/Time"
      appendTo="body"
      [ngModelOptions]="{ standalone: true }"
    ></p-calendar>

    <p-autoComplete
      [(ngModel)]="newAchievements"
      [suggestions]="searchResults"
      (completeMethod)="searchAchievements($event)"
      [multiple]="true"
      [field]="'title'"
      dataKey="id"
      placeholder="Search achievements..."
      [style]="{'width': '420px'}"
      [inputStyle]="{'width': '100%'}"
      appendTo="body"
      [ngModelOptions]="{ standalone: true }"
    >
      <ng-template let-a pTemplate="item">
        <span>{{ a.title }}<span *ngIf="a.id" style="color:#868e96; margin-left:0.4rem;">({{ a.id }})</span></span>
      </ng-template>
    </p-autoComplete>

    <p-button
      label="+ Add"
      styleClass="p-button-outlined p-button-sm"
      (onClick)="addRow()"
    ></p-button>
  </div>

  <small *ngIf="!readonly && errorMessage" class="p-error" style="display:block; margin-bottom: 0.5rem;">
    {{ errorMessage }}
  </small>
  <small *ngIf="!readonly && !errorMessage && hasPendingSelection" class="pending-hint">
    <i class="pi pi-info-circle"></i>
    Click <b>+ Add</b> to include this selection before saving.
  </small>

</div>
